module.exports = __webpack_public_path__ + "static/media/driver.bccb5d99.png";